import { useCurrentStream } from '../../feature-player/hooks/player-instance/use-current-stream';

import { useMovieTrailerOtt } from './use-movie-trailer-ott';

export const useMovieTrailerCurrentStream = (contentId: string) => {
    const trailerOtt = useMovieTrailerOtt(contentId);

    return useCurrentStream(trailerOtt?.streams);
};
